import React from 'react';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('SelectScenarioButton', theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(2),
  },
}));

const SelectScenario = () => {
  const classes = useStyles();
  const { pageContentResource } = usePageContentContext();
  const { loadModalCollectionByLink } = useModalContext();

  const handleClick = () => {
    const selectLink = pageContentResource
      .relationship(fr.relationships.activationConfirmation.name)
      .link('related')
      .url();

    loadModalCollectionByLink(selectLink);
  };

  return (
    <div className={classes.root}>
      <RoundedButton
        size={'sm'}
        fullWidth
        color="primary"
        onClick={() => {
          return handleClick();
        }}
      >
        {pageContentResource.attr('actionText')}
      </RoundedButton>
    </div>
  );
};

export default SelectScenario;
